import { confirmable } from "react-confirm";

import { Button, Header, Modal } from "simplydo/react/ui";

type AlertModalProps = {
  show?: boolean;
  proceed?: () => void;
  dismiss?: () => void;
  title: string;
  confirmation: string;
};

const AlertModal = ({
  show,
  proceed,
  dismiss,
  title,
  confirmation,
}: AlertModalProps) => {
  return (
    <Modal
      mountNode={document.getElementById("semantic-modal-mount-node")}
      open={!!show}
      onClose={dismiss ?? (() => {})}
      basic
      size="small"
      className="no-scroll"
    >
      <Header content={title} />
      <Modal.Content>{confirmation}</Modal.Content>
      <Modal.Actions>
        <Button
          color="green"
          inverted
          onClick={proceed ?? (() => {})}
          content="OK"
        />
      </Modal.Actions>
    </Modal>
  );
};

export default confirmable(AlertModal);
